export function actionSetAffiliates(value) {
    return {
        type: 'SET_AFFILIATES',
        value: value
    };
}
